import {useLocale} from "next-intl";
import {usePathname, useRouter} from "@/i18n/navigation";
import styled from "styled-components";
import {GrLanguage} from "react-icons/gr";
import {IoIosArrowDown} from "react-icons/io";
import {useEffect, useRef, useState} from "react";
import DropdownBg from "@public/assets/main/dropdown_bg.png"
import {LANGUAGE_LIST} from "@/components/constants";

const LocaleSelect = () => {
    const locale = useLocale();
    const pathname = usePathname();
    const router = useRouter();
    const [isOpen, setIsOpen] = useState(false);

    const wrapRef = useRef(null);

    const onChangeLang = (value) => {
        if (!value || value === locale) return;
        router.push(pathname, {locale: value});
        setIsOpen(false); // 언어 선택하면 닫기
    };

    useEffect(() => {
        if (!isOpen) return;

        const handleClickOutside = (e) => {
            if (wrapRef.current && !wrapRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    return (
        <LangSelectWrap ref={wrapRef}>
            <LangSelectBtn
                onClick={() => setIsOpen(prev => !prev)}
                className={isOpen ? "active" : ""}
            >
                <div className="icon">
                    <GrLanguage/>
                </div>
                <span>Language</span>
                <div className="arrow">
                    <IoIosArrowDown/>
                </div>
            </LangSelectBtn>

            <LangListWrap className={isOpen ? "active" : ""}>
                <div className="item-wrap">
                    {LOCALE_LIST.map((item, idx) => (
                        <div
                            key={idx}
                            className={`items ${locale === item.value ? "on" : ""}`}
                            onClick={() => onChangeLang(item.value)}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
            </LangListWrap>
        </LangSelectWrap>
    );
};
const LangSelectWrap = styled.div`
    position: relative;
`
const LangListWrap = styled.div`
    position: absolute;
    top: 25px;
    left: 50%;
    transform: translateX(-50%) translateY(-6px) scale(0.95);
    width: 140px;
    height: 98px;
    background-image: url(${DropdownBg?.src});
    background-repeat: no-repeat;
    background-size: cover;



    opacity: 0;
    pointer-events: none;
    transition:
            opacity 0.18s ease-out,
            transform 0.18s cubic-bezier(0.34, 1.56, 0.64, 1);

    &.active {
        opacity: 1;
        pointer-events: auto;
        transform: translateX(-50%) translateY(0) scale(1);
    }
    .item-wrap{
        padding: 20px 15px 0;
        .items{
            font-weight: 400;
            font-size: 14px;
            color: #1E2124;
            background-color: #fff;
            padding: 5px 10px;
            &.on{
                font-weight: 600;
                background-color: #EEF2F7;
                border-radius: 6px;
            }
        }
    }
`
const LangSelectBtn = styled.div`
    display: flex;
    align-items: center;
    .arrow{
        display: flex;
        align-items: center;
        transition: all .3s ease-in-out;
        svg{
            //width: 14px;
        }
    }
    .icon{
        display: flex;
        align-items: center;
    }
    span{
        display: inline-block;
        margin: 0 2px 0 4px;
        font-weight: 400;
        font-size: 15px;
        color: #1E2124;
        transform: translateY(-1px);
    }
    &.active{
        .arrow{
            transform: rotate(180deg);
        }
    }
`


const LOCALE_LIST = [
    {label: "한국어", value: LANGUAGE_LIST[0]},
    {label: "English (영어)", value: LANGUAGE_LIST[1]},
]
export default LocaleSelect;